"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _utils = require("./utils");

var colors = {
  red: '#DB2828',
  blue: '#006FBF',
  darkGray: '#212121',
  gray: '#212121',
  lightGray: '#BBBBBB',
  orange: '#EF7D4A',
  green: '#3DAF4E',
  white: '#FFFFFF'
};

var makeTintUsing = function makeTintUsing(colors, colorFn) {
  return Object.keys(colors).reduce(function (tints, c) {
    return tints[c] = new Array(11).fill(0).reduce(function (cols, _, i) {
      return cols[100 - 10 * i] = colorFn(colors[c], 5 * i), cols;
    }, {}), tints;
  }, {});
};

var tints = {
  light: makeTintUsing(colors, _utils.lighten),
  dark: makeTintUsing(colors, _utils.darken)
};

var _default = (0, _objectSpread2.default)({}, colors, {
  colors: colors,
  tints: tints,
  buttonPrimary: colors.blue,
  buttonPrimaryHover: tints.light.blue['90'],
  buttonSecondary: colors.orange,
  buttonSecondaryHover: tints.dark.orange['90'],
  loginButton: colors.orange,
  loginHeader: colors.blue,
  loginHeaderText: colors.white,
  maintenanceHeader: colors.orange,
  navBarBackground: colors.blue,
  navBarBoxShadow: '0px 5px 12px 0px rgba(0, 0, 0, 0.25)',
  navBarText: colors.white,
  navBarSelectedTabUnderline: 'rgba(0,0,0,0)',
  navBarSelectedTabBackground: 'rgba(0,0,0,0.1)',
  navBarTabSeparator: 'rgba(34,36,38,0.1)',
  navBarSubtitle: 'rgba(0,0,0,0)',
  navBarDividerBG: 'rgba(255,255,255,0.08)',
  navBarDividerBGC: 'rgba(34,36,38,0.1)',
  navBarOrgName: colors.white,
  subTabActiveLine: colors.blue,
  subTabInactive: '#F2F2F2',
  text: colors.darkGray
});

exports.default = _default;